module.exports = __webpack_public_path__ + "img/gotomeeting.7ad0b759.svg";